import { Colors } from 'planoplan-ui-kit/core/colors';
import { IS_PRODUCTION_HOST } from '@constants';
import { OS, BLOG_CATEGORIES, EDUCATION_CATEGORIES, ERROR_MESSAGE_CATEGORIES, BANNERS } from './index';

export const TRANSLATIONS_PATTERNS = [
  /^site./,
  /^store./,
  /^form_entry./,
  /^gallery./,
  /^estimate./,
  /^user_widget./,
  /^pricing.shortcontent./,
  /^country./,
];

// mobile - tablet-portrait, tablet-portrait - tablet-landscape,  tablet-landscape - >
export const INDENT_LEVELS = {
  night: [110, 142, 180],
  coal: [86, 110, 138],
  colar: [30, 60, 90],
  dull_red: [25, 50, 60],
  frog_green: [20, 40, 60],
  electric_blue: [20, 40, 50],
  dark_cream: [20, 30, 40],
  whisper: [15, 20, 30],
  azure: [10, 15, 20],
  ivory: [6, 8, 10],
  blog_description_bottom: [20, 25, 30],
  blog_description_top: [10, 10, 15, 20],
  blog_header: [56, 60, 70, 80],
  blog_body: [40, 40, 50, 60],
  blog_page: [0, 0, 40, 42],
  accent_block: [16, 25, 30, 35],
  accent_outer: [32, 35, 40, 50],
  blog_img: [30, 35, 40, 50],
  showcase_outer: [56, 90, 90],
  showcase_block: [32, 40, 60],
  interview: [12, 15, 15],
  dream_interior_btm: [30, 60, 138],
};

export const MODAL_ROOT = '#modal';
export const MODAL_TIMEOUT = 300;

export const EMAIL_REGEXP =
  '^[-._a-zA-Za-яA-я0-9]{2,}@(?:[a-zA-Za-яА-Я0-9][-a-z-A-Z-a-я-А-Я0-9]+\\.)+[a-z-A-Z-a-я-А-Я]{2,6}$';

export const PRICING_SHOW_RENDERS = ['render', 'panorama'];
export const PRICING_SHOW_WIDGETS = [
  'widget_publish_plan',
  'widget_publish_top',
  'widget_publish_three_quarter',
  'widget_publish_virtual_tour',
  'widget_publish_rotate_360',
];

//Добавляем страницы, на которых не будет фиксированного хедера
export const ROUTES_NOT_FIXED_HEADER = [];

export const ROUTES_NOT_FIXED_HEADER_BANNER = ['/pricing'];

export const INTERSECTION_OPTIONS = {
  rootMargin: '0px',
  threshold: 0.02,
};

const DOWNLOAD_LINKS = {
  windows: {
    dev: (locale) =>
      `https://nocdnfiles.planoplan.com/upload/standalone_build/releases${
        locale === 'ru' ? `/${locale}` : ''
      }/PlanoplanSetup.msi`,
    prod: (locale) =>
      `https://nocdnfiles.planoplan.com/upload/standalone_build/releases${
        locale === 'ru' ? `/${locale}` : ''
      }/PlanoplanSetup.msi`,
  },
  mac: {
    dev: (locale) =>
      `https://nocdnfiles.planoplan.com/upload/standalone_build/releases${
        locale === 'ru' ? `/${locale}` : ''
      }/PlanoplanSetup.pkg`,
    prod: (locale) =>
      `https://nocdnfiles.planoplan.com/upload/standalone_build/releases${
        locale === 'ru' ? `/${locale}` : ''
      }/PlanoplanSetup.pkg`,
  },
};

export const DOWNLOAD_BETA_LINKS = {
  windows: {
    dev: 'https://nocdnfiles.planoplan.com/upload/standalone_build/beta/ru/PlanoplanSetup.msi',
    prod: 'https://nocdnfiles.planoplan.com/upload/standalone_build/beta/ru/PlanoplanSetup.msi',
  },
  mac: {
    dev: 'https://nocdnfiles.planoplan.com/upload/standalone_build/beta/ru/PlanoplanSetup.pkg',
    prod: 'https://nocdnfiles.planoplan.com/upload/standalone_build/beta/ru/PlanoplanSetup.pkg',
  },
};

export const OS_OPTIONS = {
  [OS.MAC]: {
    title: 'Mac',
    getDownloadLink: IS_PRODUCTION_HOST ? DOWNLOAD_LINKS.mac.prod : DOWNLOAD_LINKS.mac.dev,
  },
  [OS.WINDOWS]: {
    title: 'Windows',
    getDownloadLink: IS_PRODUCTION_HOST ? DOWNLOAD_LINKS.windows.prod : DOWNLOAD_LINKS.windows.dev,
  },
};

export const BLOG_CATEGORIES_DEFAULT_COLOR = {
  [BLOG_CATEGORIES.ARTICLES]: Colors.education_blue,
  [BLOG_CATEGORIES.UPDATES]: Colors.education_red,
  [BLOG_CATEGORIES.OPINIONS]: Colors.education_yellow,
  [BLOG_CATEGORIES.NEWS]: Colors.education_green,
  [BLOG_CATEGORIES.INTERVIEW]: Colors.education_brown,
  [BLOG_CATEGORIES.INSTRUCTIONS]: Colors.main_blue,
};

export const EDUCATION_CATEGORIES_DATA = {
  [EDUCATION_CATEGORIES]: 'education_video',
};

export const MAX_LENGTH_COMMENTS = 2000;

export const REVIEWS_SLIDER_SETTINGS = {
  dots: true,
  arrows: true,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
};

export const MAIN_SLIDER_SETTINGS = {
  dots: false,
  arrows: false,
  infinite: true,
  speed: 1000,
  autoplaySpeed: 3000,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  adaptiveHeight: true,
  fade: true,
};

export const DISCUSS_INTERVAL_CHANGE_IMAGE = 2500;
export const DISCUSS_ANIMATION_DELAY = 1500;

export const BANNERS_OPTIONS = {
  [BANNERS.HEADER]: {
    cookieKey: 'POP_HIDDEN_HEADER_BANNER',
    maxAge: '1209600', // 14 дней
    hiddenRoutes: ['/blog-article'],
  },
  [BANNERS.CARD]: {
    cookieKey: 'POP_HIDDEN_CARD_BANNER',
    maxAge: '900',
  },
};

export const RECAPTCHA_KEY = '6Ld8A8sUAAAAAOmaiTZJEJabBhqoSKq7_V-BnmD7';

export const ERROR_MESSAGES = {
  [ERROR_MESSAGE_CATEGORIES.SUBSCRIBE]: {
    'Email is required': 'site.notification.requiredEmail',
    'Invalid email': 'site.notification.invalidEmail',
    'This email already subscribed': 'site.notification.alreadySubscribed',
    'Try again later': 'site.notification.tryLater',
    'default': 'site.notification.gallerySubscribe.error',
  },
  [ERROR_MESSAGE_CATEGORIES.DEFAULT]: {
    default: 'site.notification.tryLater',
  },
};

// Error pages
export const ERROR_PAGE_CONTENTS = {
  404: {
    message: 'site.errorPage.notFound.message',
    title: 'site.errorPage.notFound.title',
  },
  500: {
    message: 'site.errorPage.serverError.message',
    title: 'site.errorPage.serverError.title',
  },
  default: {
    message: 'site.errorPage.default.message',
    title: 'site.errorPage.default.title',
  },
};

// Text width
export const TABLET_TEXT_WIDTH = '600px';
export const LAPTOP_TEXT_WIDTH = '640px';
export const FULLHD_TEXT_WIDTH = '690px';
export const LAPTOP_BODY_WIDTH = '960px';
export const FULLHD_BODY_WIDTH = '1066px';

export const DULL_GREY = '#656565';
